import { Dispatch, FC, SetStateAction, useMemo } from "react";
import EyeTestHeaderView from "./EyeTestHeaderView";

interface EyeTestHeaderProps {
  slug: string;
  title?: string;
  translations?: Record<string, string>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onCancelBooking?: () => void;
}

const EyeTestHeader: FC<EyeTestHeaderProps> = ({ slug, title, translations, setIsOpen, onCancelBooking }) => {
  const indicators = useMemo(
    () => [
      { id: "type", label: translations?.book_type_label },
      { id: "store", label: translations?.book_store_label },
      { id: "date", label: translations?.book_date_and_time_label },
      { id: "my-info", label: translations?.book_my_info_label },
    ],
    [translations],
  );

  const { progressIndex, progressWidth } = useMemo(() => {
    let index;
    if (slug === "success") {
      index = indicators.length - 1;
    } else {
      index = indicators.findIndex((indicator) => indicator.id === slug);
    }
    const finalIndex = index === -1 ? 0 : index;
    const width = `${(finalIndex / (indicators.length - 1)) * 100}%`;
    return { progressIndex: finalIndex, progressWidth: width };
  }, [indicators, slug]);

  return (
    <EyeTestHeaderView
      title={title}
      translations={translations}
      indicators={indicators}
      progressIndex={progressIndex}
      progressWidth={progressWidth}
      setIsOpen={setIsOpen}
      isSuccessPage={slug === "success"}
      onCancelBooking={onCancelBooking}
    />
  );
};

export default EyeTestHeader;
